import React, { useCallback, useState } from "react";
import { Form, Formik } from "formik";
// import ReCAPTCHA from "react-google-recaptcha";
import WindowSize from "../../../../../constants/WindowSize";
import { isValidNewPassword } from "../../../../../utils/validators/isValidYup";
import { AppAPIService } from "../../../../../services/AppAPIService";
import useGetWindowWidth from "../../../../../utils/useGetWindowWidth";
import { Button } from "react-bootstrap";
import { IconButton, InputAdornment } from "@material-ui/core";
import { Container } from "../../../../admin/components/DepositModal/styles";
import { ContainerWithIcon } from "./styles";
import globalColors from "../../../../../../_metronic/_assets/sass/custom/globalColors.scss";
import { makeStyles, TextField } from "@material-ui/core";
import clsx from "clsx";
import { Typography } from "@mui/material";
import { CustomEyeOffIcon } from "../../../../../components/CustomIcons/CustomEyeOff";
import { CustomEyeIcon } from "../../../../../components/CustomIcons/CustomEye";

const useStyles = makeStyles({
  root: {
    "& label": {
      fontSize: "16px",
      fontWeight: "400",
      color: globalColors.textColor1,
    },
    "& label.Mui-focused": {
      color: globalColors.textColor1,
    },
    "& input": {
      padding: "12px 16px",
    },
    "& .MuiOutlinedInput-root": {
      height: "100vh",
      maxHeight: "48px",
      "& fieldset": {
        borderColor: globalColors.textColor2,
      },
      "&.Mui-focused fieldset": {
        border: `1px solid ${globalColors.primaryColor2}`,
      },
    },
  },
  multilineColor: {
    color: globalColors.textColor1,
  },
  typography: {
    fontStyle: "normal",
    fontWeight: "400",
    lineHeight: "24px",
  },
  svg: {
    color: globalColors.primaryColor2,
  },
});

export const CreatePassword = ({ code, close, resetAll }) => {
  const [newPswVisibility, setNewPswVisibility] = useState(false);
  const [confirmPswVisibility, setConfirmPswVisibility] = useState(false);

  const [isLoading, setIsLoading] = useState(false);
  const [submitError, setSubmitError] = useState("");
  const [passwordChanged, setPasswordChanged] = useState(false);
  const width = useGetWindowWidth();
  const classes = useStyles();

  const handleSubmit = useCallback(async (values, resetForm) => {
    try {
      const api = AppAPIService.getInstance();
      setIsLoading(true);
      setSubmitError("");
      await api.makeHttpRequest({
        url: "/auth/new-password",
        method: "POST",
        data: {
          token: code,
          newPassword: values.password,
        },
      });
      resetForm();
      setPasswordChanged(true);
    } catch (e) {
      const payload = e?.response?.data;
      const code = payload?.code || payload?.error?.code;
      setSubmitError(
        code === "INVALID_OR_EXPIRED_TOKEN" || e?.response?.status === 400
          ? "Este link é inválido, expirou ou já foi utilizado. Solicite um novo link de recuperação."
          : !e?.response
          ? "Não foi possível conectar ao portal. Verifique sua internet e tente novamente."
          : "Não foi possível alterar a senha agora. Tente novamente."
      );
    }

    setIsLoading(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (passwordChanged) {
    return (
      <Container style={{ width: "100%", padding: 0, textAlign: "left" }}>
        <Typography variant="h3" style={{ fontSize: "24px", fontWeight: "bold" }}>
          Senha alterada
        </Typography>
        <p>Sua nova senha foi cadastrada. Você já pode acessar o portal.</p>
        <Button
          type="button"
          className="btn btn-elevate btn-width kt-login__btn-primary"
          style={{ width: "100%", height: "50px", marginTop: "16px" }}
          onClick={() => {
            if (resetAll) resetAll();
            window.location.href = "/auth/login";
          }}
        >
          Ir para o login
        </Button>
      </Container>
    );
  }

  return (
    <>
      <Container width={width}
        style={{
          width: "100%",
          padding: "0",
        }}
      >
        <ContainerWithIcon width={width}
        >
          <Container
            style={{
              display: "block",
              textAlign: "left",
            }}
          >
            {width >= WindowSize.SM ? <Typography variant="h3" style={
              { fontSize: "24px", fontWeight: "bold" }}>Nova senha</Typography> : <Typography variant="h1" style={
                { fontSize: "32px", fontWeight: "bold" }}>Nova senha</Typography>}
            <Container
              style={{
                padding: 0,
                margin: 0,
                marginTop: "14px",
                marginBottom: "20px",
              }}
              maxWidth="xl"
            >
              <Typography className="subtitle"
                variant="p"
                style={{
                  fontSize: "14px",
                }}
              >
                Sua senha deve conter no mínimo 8 caracteres, entre letras
                maiúsculas, minúsculas, números e caracteres especiais.
              </Typography>
            </Container>
            <Formik
              initialValues={{ password: "", confirmePassword: "" }}
              validationSchema={isValidNewPassword}
              onSubmit={(values, { setSubmitting, resetForm }) => {
                handleSubmit(values, resetForm);
                setSubmitting(false);
              }}
            >
              {({ values, errors, touched, handleChange, handleBlur }) => (
                <Form>
                  <TextField
                    placeholder="Digite sua senha"
                    type={newPswVisibility ? "text" : "password"}
                    name="password"
                    value={values.password}
                    error={touched.password && errors.password ? true : false}
                    onChange={handleChange}
                    margin="normal"
                    label="Senha"
                    variant="outlined"
                    className={clsx(classes.root)}
                    onBlur={handleBlur}
                    helperText={
                      touched.password && errors.password ? errors.password : ""
                    }

                    InputLabelProps={{
                      shrink: true,
                      "*": {
                        fontSize: "22px",
                      },

                    }}
                    sx={{
                      "*": {
                        fontSize: "22px",
                      },
                    }}
                    inputProps={{
                      style: {
                        textTransform: "none"
                      }
                    }}
                    InputProps={{
                      style: {
                        borderRadius: "8px",
                        color: (errors.password && touched.password) ? globalColors.alertColor : globalColors.textColor1,
                      },
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="Alterar visibilidade da senha"
                            onClick={() =>
                              setNewPswVisibility(!newPswVisibility)
                            }
                            onMouseDown={(e) => e.preventDefault()}
                            edge="end"
                          >
                            {newPswVisibility ? (
                              <CustomEyeIcon />
                            ) : (
                              <CustomEyeOffIcon />
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />


                  <TextField
                    placeholder="Digite novamente sua senha"
                    type={confirmPswVisibility ? "text" : "password"}
                    name="confirmePassword"
                    margin="normal"
                    label="Confirmar a senha"
                    variant="outlined"
                    InputLabelProps={{ shrink: true }}
                    className={clsx(classes.root)}
                    value={values.confirmePassword}
                    style={{
                      marginTop: "25px",
                      borderRadius: "8px",
                    }}
                    sx={{
                      "& label": {
                        fontSize: "16px",
                        color: globalColors.textColor1,
                      },
                    }}
                    error={
                      touched.confirmePassword && errors.confirmePassword
                        ? true
                        : false
                    }
                    onChange={handleChange}
                    onBlur={handleBlur}
                    helperText={
                      touched.confirmePassword && errors.confirmePassword
                        ? errors.confirmePassword
                        : ""
                    }
                    inputProps={{
                      style: {
                        textTransform: "none"
                      }
                    }}
                    InputProps={{
                      style: {
                        borderRadius: "8px",
                        color: (errors.confirmePassword && touched.confirmePassword) ? globalColors.alertColor : globalColors.textColor1,
                      },
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="Alterar visibilidade da confirmação da senha"
                            onClick={() =>
                              setConfirmPswVisibility(!confirmPswVisibility)
                            }
                            onMouseDown={(e) => e.preventDefault()}
                            edge="end"
                          >
                            {confirmPswVisibility ? (
                              <CustomEyeIcon />
                            ) : (
                              <CustomEyeOffIcon />
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />

                  {/* <ContainerReCaptcha>
                    <ReCAPTCHA
                      sitekey={process.env.REACT_APP_SITE_KEY_RECAPTCHA}
                      onChange={value => {
                        setTokenReCaptcha(value);
                      }}
                    />
                  </ContainerReCaptcha> */}
                  {submitError ? (
                    <div className="xv-auth-feedback xv-auth-feedback--error" role="alert">
                      <strong>Não foi possível cadastrar a senha.</strong>
                      <span>{submitError}</span>
                    </div>
                  ) : null}
                  <Button
                    id="kt_login_signin_submit"
                    type="submit"
                    disabled={
                      isLoading ||
                      Boolean(errors.password) ||
                      !values.password ||
                      !values.confirmePassword ||
                      values.password !== values.confirmePassword
                    }
                    className={`btn btn-elevate btn-width kt-login__btn-primary justify-content-end ${clsx(
                      {
                        "kt-spinner kt-spinner--right kt-spinner--md kt-spinner--light": isLoading,
                      }
                    )}`}
                    style={{
                      width: "100%",
                      height: "50px",
                      color: globalColors.colorWhite,
                      borderRadius: "8px",
                      backgroundColor:
                        (errors.password ||
                          !values.password ||
                          !values.confirmePassword ||
                          values.password !== values.confirmePassword) ? globalColors.backgroundColor2 : globalColors.primaryColor1,
                      border: "none",
                      cursor: (errors.password
                        || !values.password
                        || !values.confirmePassword
                        || values.password !== values.confirmePassword
                      ) ? "not-allowed" : "pointer",
                      fontWeight: "bold",
                      fontSize: "15px",
                      marginTop: "25px",
                    }}
                    sx={{
                      width: "100%",
                      color: globalColors.colorWhite,
                      height: "60px",
                    }}
                    loading={isLoading}
                  >
                    {isLoading ? "Salvando..." : "Cadastrar nova senha"}
                  </Button>
                </Form>
              )}
            </Formik>
          </Container>
        </ContainerWithIcon>
      </Container>
    </>
  );
};
